import * as yup from 'yup';

import { email } from '@core/validation';

export const FormSchema = yup.object({
  email: email.required('Введите электронную почту'),
});

export type FormProps = yup.InferType<typeof FormSchema>;
